<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import { mapGetters } from 'vuex'
import { Helper } from '@/mixin/helper'
/**
 * Starter component
 */
export default {
  page: {
    title: 'Manajemen Aset',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  mixins: [Helper],
  data() {
    return {
      phaseOneShow: false,
    }
  },

  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
    }),
    title() {
      return this.$t('setting.homePage.asset')
    },
  },
}
</script>

<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" />
      <p class="mb-4">
        {{ $t('setting.homePage.textAsset') }}
      </p>
      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <b-button
            variant="outline-primary"
            class="ms-3"
            @click="$router.push({ name: 'Setting' })"
          >
            <i class="mc-fa icon-outline_arrow-left"></i>
            {{ $t('global.back') }}
          </b-button>
        </div>
      </div>
    </div>

    <div class="card mc-card mc-card-front">
      <div class="card-body">
        <b-row class="mc-card__list">
          <b-col v-if="hasAccess(['c11a-default-gps:read'])" sm="12" md="12">
            <b-button
              variant="outline-light"
              class="d-block w-100 mc-card__list-item clearfix"
              @click="$router.push({ name: 'Management GPS' })"
            >
              <div class="mc-card__list-item-content ps-0">
                <h4>{{ $t('setting.list.managementAsset.gps.title') }}</h4>
                <p>{{ $t('setting.list.managementAsset.gps.subtitle') }}</p>
              </div>
              <i class="mc-fa-right icon-fill_arrow-ios-right"></i>
            </b-button>
          </b-col>

          <b-col
            v-if="hasAccessAll(['c11b-default-subdomain:read', 'c11b-default-subdomain:update'])"
            sm="12"
            md="12"
          >
            <b-button
              variant="outline-light"
              class="d-block w-100 mc-card__list-item clearfix"
              @click="$router.push({ name: 'Management Domain' })"
            >
              <div class="mc-card__list-item-content ps-0">
                <h4>{{ $t('setting.list.managementAsset.subdomain.title') }}</h4>
                <p>{{ $t('setting.list.managementAsset.subdomain.subtitle') }}</p>
              </div>
              <i class="mc-fa-right icon-fill_arrow-ios-right"></i>
            </b-button>
          </b-col>
        </b-row>
      </div>
    </div>
  </Layout>
</template>
